/**
 * Voice Track Utils
 *
 * @module lib/VoiceTrackUtils
 */
import { TrackType } from '../constants/TrackType';

export function isStationVoiceTrack(track: $TSFixMe): boolean {
  return !!track && !!track.get('pandoraId') && track.get('trackType') === TrackType.VOICE_TRACK;
}

export function getVoiceTrackDeliveryType(track: $TSFixMe): $TSFixMe {
  if (!track || !isStationVoiceTrack(track)) return;
  return track.get('voiceTrackDeliveryType');
}
